const GridCardConfigData = {
  parameters: [
    {
      key: "bhk",
      values: ["3.5"],
    },
  ],
  label: "3.5 BHK",
};

export default GridCardConfigData;
